import React, { useRef, useState, useEffect } from "react";


import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import LogoGeosoftsolutions from "../assets/LogoGeosoftsolutions.png";
import LoginComponent from "../components/login/Login";
import ChangeFirstPassword from "../components/login/ChangeFirstPassword";

function Login() {
 
  //snackbar de alertas
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
  });

  const [isFirstTime, setFirstTime ] = useState(false);
  const [userEmail, setUserEmail] = useState();

  //cierra el snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );


  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        ContentProps={{
          sx: {
            color: "#fffcfc"
          },
        }}
      />

      <div className="min-h-[calc(82vh)] flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="w-full rounded-lg shadow-xl md:mt-0 sm:max-w-md xl:p-0 bg-ceniza_light border-gray-700">
          <div className="p-6 space-y-4 md:space-y-4 sm:p-4">
            <img
              className="w-[220px] h-auto mx-auto"
              src={LogoGeosoftsolutions}
              alt="logo"
            />

            {isFirstTime ? (
              <ChangeFirstPassword 
                setSnackbar={setSnackbar}
                userEmail={userEmail}
              />
            ) : (
              <LoginComponent
                setSnackbar={setSnackbar} 
                setFirstTime={setFirstTime}
                setUserEmail={setUserEmail}
              />
            )}

          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
